import extend from '@/utils/vuex-extend';
import {dialog, table} from '@/vuex-extend';
import {fetchList, fetchUserNoteList, fetchUserOrderList, getConsumerDetail} from '@/api/cs/consumer';
import {wait} from '@/utils/wait';
import {Message} from 'element-ui';

export default extend(dialog, table, {
	namespaced: true,
	state: {
		userId: 0,
		detail: {},
		list: [],
		page:{
			pageSize:10,
		}
	},
	actions: {
		async afterOpenDialog({dispatch, commit, state}, payload) {
			const {userId} = state;
			await wait(dispatch, 'cs.consumer.detail', async function () {
				let response = await getConsumerDetail({userId});
				if (response.data) {
					commit('save', {
						detail: response.data
					})
					dispatch('getList')
				} else {
					Message.error({
						message: '用户不存在',
						onClose: () => {
							dispatch('closeDialog')
						}
					})
				}
			})
		},

		async getList({dispatch, state}, payload) {
			await wait(dispatch, 'cs.consumer.note-list', async function () {
				const {userId} = state
				await dispatch('getData', {
					caller: fetchUserNoteList,
					options: {
						userId,
						...payload
					}
				});
			})
		}

	}
})



// WEBPACK FOOTER //
// ./src/store/modules/cs/consumer/detail.js